import { Project } from '@arra/core';

export const sortByDate = (a: Project, b: Project) => {
  return (
    (new Date(b.updatedAt) || new Date(b.createdAt)).getTime() -
    (new Date(a.updatedAt) || new Date(a.createdAt)).getTime()
  );
};

export const downloadFile = (blob: Blob, fileName: string) => {
  const anchorElement = document.createElement('a');

  document.body.appendChild(anchorElement);

  anchorElement.style.display = 'none';

  const url = window.URL.createObjectURL(blob);

  anchorElement.href = url;
  anchorElement.download = fileName;
  anchorElement.click();

  window.URL.revokeObjectURL(url);
};
